<template>
  <div>
    <img alt="ambiFOX Logo" src="./../assets/logo.png" class="bild" />
    <h1>Hungry? Order!</h1>

    <a :href="url" target="_blank">
      <img
        alt="menue card"
        src="./../assets/info.png"
        class="btn btn--min-b-radius"
      /> </a
    ><br />
    <div class="meal-type-toggle">
      <div
        class="meal-type-option"
        :class="{ active: selectedMealType === 'daily' }"
        @click="selectMealType('daily')"
      >
        <img
          class="btn"
          alt="Tagesgericht auswählen"
          src="./../assets/check.png"
        />
        <span>Tagesgericht</span>
      </div>
      <div
        class="meal-type-option"
        :class="{ active: selectedMealType === 'weekly' }"
        @click="selectMealType('weekly')"
      >
        <img
          class="btn"
          alt="Wochengericht auswählen"
          src="./../assets/check.png"
        />
        <span>Wochengericht</span>
      </div>
    </div>
    <p>
      Auswahl: <strong>{{ mealTypeLabel }}</strong>
    </p>
    <p>
      Please choose your amount of meals for <br />
      <strong>{{ next_possible_order_date.toDateString() }}</strong>
    </p>
    <p>
      Amount: <strong>{{ order_amount }}</strong>
    </p>
    <img
      class="btn"
      alt="more"
      src="./../assets/more.png"
      @click="increaseAmount"
    />
    <img
      class="btn"
      alt="less"
      src="./../assets/less.png"
      @click="decreaseAmount"
    />

    <br /><br />

    <img
      class="btn"
      alt="order"
      src="./../assets/check.png"
      @click="placeOrder"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import axios from "axios";
import { MealType } from "@/types/orders";
import auth from "../auth";

type OrderPageState = {
  next_possible_order_date: Date;
  order_amount: number;
  selectedMealType: MealType;
};

export default defineComponent({
  name: "OrderPage",
  data(): OrderPageState {
    return {
      next_possible_order_date: new Date(),
      order_amount: 1,
      selectedMealType: "daily",
    };
  },
  computed: {
    url() {
      return process.env.VUE_APP_KANTINE;
    },
    mealTypeLabel(): string {
      return this.selectedMealType === "weekly"
        ? "Wochengericht"
        : "Tagesgericht";
    },
  },
  created() {
    this.findNextOrderDate();
  },
  methods: {
    findNextOrderDate() {
      const nextDate = new Date();
      nextDate.setDate(nextDate.getDate() + 1);

      const possibleDaysRaw = process.env.VUE_APP_POSS_NEXT_ORDER_DATE;
      const possibleDays = possibleDaysRaw ? possibleDaysRaw.split(",") : [];

      // Spätester Zeitpunkt der Bestellung ist der Vortag 14:00 Uhr
      if (nextDate.getHours() >= 14) {
        nextDate.setDate(nextDate.getDate() + 1);
      }

      // Es soll nur der nächstmögliche Tag angegeben werden.
      while (
        possibleDays.length &&
        !possibleDays.includes(`${nextDate.getDay()}`)
      ) {
        nextDate.setDate(nextDate.getDate() + 1);
      }

      this.next_possible_order_date = nextDate;
    },
    // Manuelles Erhöhen der zu bestellenden Menge bis zu einem Max von 9
    increaseAmount() {
      if (this.order_amount < 9) {
        this.order_amount += 1;
      }
    },
    // Manuelles Verringern der zu bestellenden Menge bis zu einem Min von 1
    decreaseAmount() {
      if (this.order_amount > 1) {
        this.order_amount -= 1;
      }
    },
    // Übergabe der zu bestellenden Menge des Menüs zum nächstmöglichen Bestelldatum
    async placeOrder() {
      const dateDe = this.next_possible_order_date.toLocaleDateString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      try {
        await axios.post(
          `${process.env.VUE_APP_BACKEND_URL}/api/v1/orders`,
          {
            amount: this.order_amount,
            delivery_date: dateDe.replaceAll(".", "-"),
            meal_type: this.selectedMealType,
          },
          auth.getHeader()
        );
        window.alert(
          `${this.order_amount} Meal${this.order_amount > 1 ? "s" : ""} (${
            this.mealTypeLabel
          }) for ${this.next_possible_order_date.toDateString()} have been ordered`
        );

        this.$emit("change-page", "ORDER_HISTORY");
      } catch (error) {
        window.alert(error);
      }
    },
    selectMealType(type: MealType) {
      this.selectedMealType = type;
    },
  },
});
</script>
